// extracted by mini-css-extract-plugin
export var dataCell = "_oc-2";
export var dataRow = "_oc-0";
export var headerRow = "_oc-1";